export default {
  // Header Navigation
  'nav.hotels': 'Otal',
  'nav.flights': 'Jiragen Sama',
  'nav.taxi': 'Taksi',
  'nav.packages': 'Fakiti',
  'nav.aiBooking': 'Ajiya ta AI',
  'nav.hajjUmrah': 'Hajji/Umrah',
  'nav.signIn': 'Shiga',
  'nav.language': 'Hausa',
  'nav.currency': 'USD',
  
  // Sign In Modal
  'signIn.title': 'Shiga zuwa Rigland Travels Ltd',
  'signIn.email': 'Imel',
  'signIn.password': 'Kalmar Sirri',
  'signIn.emailPlaceholder': 'Shigar da imel ɗinku',
  'signIn.passwordPlaceholder': 'Shigar da kalmar sirri',
  'signIn.button': 'Shiga',
  'signIn.noAccount': 'Ba ku da asusu?',
  'signIn.createOne': 'Ƙirƙiri ɗaya',
  
  // Search Widget
  'search.hotels': 'Otal',
  'search.flights': 'Jiragen Sama',
  'search.taxi': 'Taksi',
  'search.packages': 'Fakiti',
  'search.aiBooking': 'Ajiya ta AI',
  'search.hajjUmrah': 'Hajji/Umrah',
  'search.destination': 'Ina kuke zuwa?',
  'search.checkIn': 'Shiga',
  'search.checkOut': 'Fita',
  'search.guests': 'Baƙi',
  'search.searchButton': 'Bincika',
  'search.from': 'Daga',
  'search.to': 'Zuwa',
  'search.departure': 'Tashi',
  'search.return': 'Dawowa',
  'search.passengers': 'Fasinjoji',
  'search.pickUp': 'Wurin ɗauka',
  'search.dropOff': 'Wurin sauka',
  'search.pickUpDate': 'Ranar ɗauka',
  'search.dropOffDate': 'Ranar sauka',
  'search.packageType': 'Nau\'in fakiti',
  'search.activity': 'Me kuke son yi?',
  'search.date': 'Rana',
  'search.departureDate': 'Ranar tashi',
  'search.returnDate': 'Ranar dawowa',
  'search.pilgrims': 'Mahajjata',
  
  // Home Page
  'home.hero.title': 'Tafiyarku Ta Fara Nan',
  'home.hero.subtitle': 'Gano wurare masu ban sha\'awa, yi ajiyar jiragen sama, otal, kuma ƙirƙiri abubuwan tunawa da Rigland Travels Ltd',
  'home.popularDestinations': 'Wurare Masu Shahara',
  'home.exploreWorld': 'Bincika Duniya',
  'home.whyChooseUs': 'Me yasa Za Ku Zaɓe Mu',
  'home.bestPrices': 'Mafi Kyawun Farashi',
  'home.bestPricesDesc': 'Muna tabbatar da mafi kyawun farashi don duk bukatun tafiyarku',
  'home.support': 'Tallafi 24/7',
  'home.supportDesc': 'Ƙungiyarmu tana shirye koyaushe don taimaka muku',
  'home.easyBooking': 'Sauƙin Ajiya',
  'home.easyBookingDesc': 'Yi ajiyar tafiyarku cikin dannawa kaɗan',
  'home.trustedPartner': 'Abokin Amana',
  'home.trustedPartnerDesc': 'Sama da shekaru 10 na kyakkyawan aiki a harkokin tafiye-tafiye',
  
  // Hotels Page
  'hotels.title': 'Nemo Otal ɗinku Mai Kyau',
  'hotels.subtitle': 'Gano otal masu jin daɗi a Kaduna da sauransu',
  'hotels.featured': 'Otal Masu Shahara a Kaduna',
  'hotels.categories': 'Nau\'in Otal',
  'hotels.luxury': 'Otal Masu Alatu',
  'hotels.business': 'Otal Kasuwanci',
  'hotels.budget': 'Otal Mai Arha',
  'hotels.perNight': 'kowace dare',
  'hotels.viewDetails': 'Duba Cikakken Bayani',
  'hotels.rooms': 'Ɗakuna',
  'hotels.adults': 'Manya',
  'hotels.children': 'Yara',
  
  // Flights Page
  'flights.title': 'Yi Ajiyar Jirgin Sama',
  'flights.subtitle': 'Nemo mafi kyawun jiragen sama zuwa inda kuke zuwa',
  'flights.roundTrip': 'Tafiya da dawowa',
  'flights.oneWay': 'Tafiya ɗaya',
  'flights.multiCity': 'Birane da yawa',
  'flights.popularRoutes': 'Hanyoyi Masu Shahara Daga Kaduna',
  'flights.ourPartners': 'Abokan Hulɗar Jiragen Sama',
  'flights.economy': 'Tattalin Arziki',
  'flights.premiumEconomy': 'Babban Tattalin Arziki',
  'flights.business': 'Kasuwanci',
  'flights.firstClass': 'Aji na Farko',
  'flights.infants': 'Jarirai',
  
  // Taxi Page
  'taxi.title': 'Yi Ajiyar Taksi',
  'taxi.subtitle': 'Sabis na taksi mai aminci zuwa inda kuke zuwa',
  'taxi.categories': 'Nau\'in Taksi',
  'taxi.economy': 'Tattalin Arziki',
  'taxi.standard': 'Daidaitacce',
  'taxi.suv': 'SUV',
  'taxi.executive': 'Babba',
  'taxi.serviceAreas': 'Wuraren Sabis a Kaduna',
  'taxi.features': 'Sabis ɗin Taksi',
  'taxi.professionalDrivers': 'Direbobi Ƙwararru',
  'taxi.professionalDriversDesc': 'Direbobi masu gogewa da ladabi',
  'taxi.safetyFirst': 'Aminci Da Farko',
  'taxi.safetyFirstDesc': 'Motoci masu kyau tare da inshora',
  'taxi.affordablePrices': 'Farashi Mai Araha',
  'taxi.affordablePricesDesc': 'Farashi bayyananne ba tare da ɓoyayyun kudade ba',
  'taxi.support': 'Samuwa 24/7',
  'taxi.supportDesc': 'Yi ajiya koyaushe, ko\'ina',
  
  // Packages Page
  'packages.title': 'Fakitin Tafiya',
  'packages.subtitle': 'Gano fakitin tafiyarmu don abubuwan tunawa',
  'packages.categories': 'Nau\'in Fakiti',
  'packages.flightHotel': 'Jirgin Sama + Otal',
  'packages.hajjUmrah': 'Hajji & Umrah',
  'packages.allInclusive': 'Duk An Haɗa',
  'packages.familyPackages': 'Fakitin Iyali',
  'packages.honeymoon': 'Watan Zuma',
  'packages.adventure': 'Kasada',
  'packages.vacation': 'Fakitin Hutu',
  'packages.specialDeals': 'Ciniki Na Musamman',
  'packages.perPerson': 'kowace mutum',
  'packages.days': 'kwanaki',
  'packages.bookNow': 'Yi Ajiya Yanzu',
  'packages.save': 'Ajiye',
  
  // AI Booking Page
  'aiBooking.title': 'Mataimakin Ajiya na AI',
  'aiBooking.subtitle': 'Yi ajiyar tafiyarku ta hanyar hira da mataimakin AI',
  'aiBooking.heroTitle': 'Yi Ajiyar Jiragen Sama da AI',
  'aiBooking.heroSubtitle': 'Kawai gaya mana inda kuke son zuwa, AI ɗinmu zai kula da komai',
  'aiBooking.placeholder': 'Rubuta bukatun tafiyarku... misali, "Ina son tashi daga Lagos zuwa London mako mai zuwa"',
  'aiBooking.send': 'Aika',
  'aiBooking.examples': 'Gwada tambaya:',
  'aiBooking.example1': 'Yi ajiyar jirgin sama daga Abuja zuwa Dubai don fasinjoji 2',
  'aiBooking.example2': 'Ina buƙatar tafiya da dawowa zuwa London tashi Litinin mai zuwa',
  'aiBooking.example3': 'Nemo min jirgin sama mafi arha zuwa New York a watan Disamba',
  'aiBooking.example4': 'Tikiti na aji na kasuwanci zuwa Paris don iyalina',
  'aiBooking.howItWorks': 'Yadda Yake Aiki',
  'aiBooking.step1': 'Yi Hira da AI',
  'aiBooking.step1Desc': 'Gaya wa mataimakin AI inda kuke son zuwa',
  'aiBooking.step2': 'Sami Zaɓuɓɓuka',
  'aiBooking.step2Desc': 'AI yana bincika kuma yana gabatar da mafi kyawun zaɓuɓɓukan jirgin sama',
  'aiBooking.step3': 'Gyara Bincike',
  'aiBooking.step3Desc': 'Yi tambayoyi kuma daidaita abubuwan da kuke so',
  'aiBooking.step4': 'Kammala Ajiya',
  'aiBooking.step4Desc': 'Tabbatar da kuma biya - duk ta hanyar hira',
  'aiBooking.features': 'Me yasa Za Ku Yi Amfani da Ajiya ta AI',
  'aiBooking.natural': 'Hira Ta Dabi\'a',
  'aiBooking.naturalDesc': 'Yi ajiyar jiragen sama yadda kuke magana',
  'aiBooking.smart': 'Shawarwari Masu Hankali',
  'aiBooking.smartDesc': 'AI yana ba da shawarar mafi kyawun zaɓuɓɓuka a gare ku',
  'aiBooking.fast': 'Sauri Kamar Walƙiya',
  'aiBooking.fastDesc': 'Kammala ajiya cikin mintuna kaɗan',
  'aiBooking.support': 'Samuwa 24/7',
  'aiBooking.supportDesc': 'Mataimakin AI koyaushe shirye don taimako',
  'aiBooking.startChat': 'Fara hira don yin ajiyar jirgin sama...',
  
  // Hajj/Umrah Page
  'hajj.title': 'Fakitin Hajji & Umrah',
  'hajj.subtitle': 'Cika tafiyar ruhaniyarku tare da cikakkun fakitinmu',
  'hajj.packages': 'Fakitin Hajji',
  'hajj.umrahPackages': 'Fakitin Umrah',
  'hajj.premium': 'Babba',
  'hajj.standard': 'Daidaitacce',
  'hajj.luxury': 'Alatu',
  'hajj.economy': 'Tattalin Arziki',
  'hajj.days': 'kwanaki',
  'hajj.perPerson': 'kowace mutum',
  'hajj.bookNow': 'Yi Ajiya Yanzu',
  'hajj.includes': 'Fakitin Ya Haɗa',
  'hajj.flights': 'Jiragen sama na dawowa daga Kaduna',
  'hajj.accommodation': 'Masauki a Makka & Madina',
  'hajj.meals': 'Abinci na yau da kullun',
  'hajj.transport': 'Sufurin ƙasa',
  'hajj.guidance': 'Jagorar addini',
  'hajj.visa': 'Aiki na biza',
  'hajj.additionalServices': 'Ƙarin Sabis',
  'hajj.visaService': 'Taimakon Biza',
  'hajj.visaServiceDesc': 'Cikakken tallafin aiki na biza',
  'hajj.insurance': 'Inshorar Tafiya',
  'hajj.insuranceDesc': 'Cikakken ɗaukar nauyi don kwanciyar hankali',
  'hajj.ziyarat': 'Yawon Ziyarat',
  'hajj.ziyaratDesc': 'Yawon shakatawa zuwa wuraren tarihi na Musulunci',
  'hajj.religiousGuides': 'Jagororin Addini',
  'hajj.religiousGuidesDesc': 'Malaman ƙwararru don jagorantar tafiyarku',
  'hajj.ourGuides': 'Jagororin Addininmu Ƙwararru',
  'hajj.yearsExperience': 'shekaru na gogewa',
  
  // Footer
  'footer.about': 'Game da Rigland Travels Ltd',
  'footer.aboutDesc': 'Abokin hulɗarku mai aminci don duk bukatun tafiya a Najeriya da sauransu. Muna ba da sabis na musamman don otal, jiragen sama, sabis na taksi, fakiti, da aikin Hajji/Umrah.',
  'footer.quickLinks': 'Hanyoyin Sauri',
  'footer.services': 'Sabis',
  'footer.contact': 'Tuntube Mu',
  'footer.phone': 'Waya',
  'footer.email': 'Imel',
  'footer.address': 'Adireshi',
  'footer.followUs': 'Bi Mu',
  'footer.newsletter': 'Yi Rajista ga Wasiƙarmu',
  'footer.newsletterDesc': 'Sami sabbin cinikin tafiya da sabuntawa',
  'footer.emailPlaceholder': 'Shigar da imel ɗinku',
  'footer.subscribe': 'Yi Rajista',
  'footer.rights': 'Duk haƙƙoƙi an kiyaye su',
  'footer.privacy': 'Manufar Sirri',
  'footer.terms': 'Sharuɗɗan Sabis',
  
  // Common
  'common.loading': 'Ana ɗorawa...',
  'common.error': 'Kuskure',
  'common.success': 'Nasara',
  'common.cancel': 'Soke',
  'common.confirm': 'Tabbatar',
  'common.close': 'Rufe',
  'common.save': 'Ajiye',
  'common.edit': 'Gyara',
  'common.delete': 'Share',
  'common.viewMore': 'Duba Ƙari',
  'common.learnMore': 'Koyi Ƙari',
};

export const ha = {
  // ... existing translations ...
  
  auth: {
    signIn: 'Shiga',
    signUp: 'Yi Rajista',
    signInSubtitle: 'Maraba da komowa! Don Allah shiga cikin asusunka',
    signUpSubtitle: 'Kirkiro asusunka don fara yin booking na tafiye-tafiye masu ban sha\'awa',
    signInWithGoogle: 'Ci gaba da Google',
    signUpWithGoogle: 'Yi rajista da Google',
    orContinueWith: 'ko ci gaba da email',
    firstName: 'Sunan Farko',
    lastName: 'Sunan Iyali',
    phoneNumber: 'Lambar Waya',
    emailAddress: 'Adireshin Email',
    password: 'Kalmar Sirri',
    createAccount: 'Kirkiro Asusu',
    processing: 'Ana Aiki...',
    agreeToTerms: 'Na yarda da',
    termsOfService: 'Sharuddan Sabis',
    and: 'da',
    privacyPolicy: 'Manufar Sirri',
    noAccount: 'Ba ka da asusu ba?',
    haveAccount: 'Kana da asusu tuni?',
    forgotPassword: 'Ka manta da kalmar sirri?',
    registrationSuccess: 'An Yi Rajista Nasara!',
    registrationSuccessMessage: 'An kirkiro asusunka cikin nasara.',
    signinSuccess: 'Maraba da Komowa!',
    signinSuccessMessage: 'An shiga cikin nasara.'
  }
};